import { listenFromSfPortal } from './sfPortalActions';
import getSfPortalConnector from './getSfPortalConnector';
import { PORTAL_EVENTS } from './constants';

export default function connectToSfPortal(store) {
  // Hack required for the test
  return (
    listenFromSfPortal &&
    listenFromSfPortal(PORTAL_EVENTS.dispatch, getSfPortalConnector(store))
  );
}
